var controller = new ScrollMagic.Controller();
jQuery(document).ready(function ($) {
    $(".lglt-section-image--info").each(function(i) {
        var inner = $(this);

        var tl = new TimelineMax();
        //check is even or odd
        if ((i % 2 == 0)) {
            tl.fromTo(inner, 0.5, { xPercent: -100 }, { xPercent: 0 } );
        } else {
            tl.fromTo(inner, 0.5, { xPercent: 100 }, { xPercent: 0 } );
        }

        var scene = new ScrollMagic.Scene({
        triggerElement: this,
            triggerHook: 0.8,
        })
        // .addIndicators({
        //     colorTrigger: "white",
        //     colorStart: "white",
        //     colorEnd: "white",
        //     indent: 5
        // })
        .setTween(tl)
        .reverse(false)
        .addTo(controller);
    });

    $(".animate-fadeintop").each(function(i) {
        var inner = $(this);

        var tl = new TimelineMax();
        tl.fromTo(inner, 0.5, { position: 'relative', top: 100, opacity: 0 }, { position: 'relative', top: 0, opacity: 1 } );


        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.8,
        })
        // .addIndicators({
        //     colorTrigger: "red",
        //     colorStart: "red",
        //     colorEnd: "red",
        //     indent: 5
        // })
        .setTween(tl)
        .reverse(false)
        .addTo(controller);
    });



});
